import { render } from "./PotentialMap.vue?vue&type=template&id=6109754a&lang=pug"
import script from "./PotentialMap.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialMap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__